import StatesFilter from "./states-filter.vue";

export default StatesFilter;



// WEBPACK FOOTER //
// ./src/components/_dashboard/states/filter/index.js